import { render, staticRenderFns } from "./InputsPedidosDCC.vue?vue&type=template&id=28e5f292&scoped=true&"
import script from "./InputsPedidosDCC.vue?vue&type=script&lang=js&"
export * from "./InputsPedidosDCC.vue?vue&type=script&lang=js&"
import style0 from "./InputsPedidosDCC.vue?vue&type=style&index=0&id=28e5f292&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5f292",
  null
  
)

export default component.exports